'use client';

import Image from 'next/image';
import { useTransition } from 'react';
import clsx from 'clsx';
import { Tooltip } from './Tooltip';

export function CardInputButton({
  data,
  selected,
  handleChange,
  name,
  disabled,
  className,
  textClass,
}: {
  data: { id: number; name: string; picture: string; popuptext?: string };
  selected: boolean;
  handleChange: (event: string) => void;
  name: string;
  disabled?: boolean;
  className?: string;
  textClass?: string;
}) {
  const [isPending, startTransition] = useTransition();

  return (
    <Tooltip tip={disabled ? data.popuptext : undefined} colorMode="primary">
      <div
        className={clsx(
          'card card-border relative items-center',
          !selected ? 'border-base-300' : 'border-primary',
          className,
        )}
      >
        <input
          disabled={isPending || disabled}
          className={clsx('absolute left-0 top-0 h-full w-full cursor-pointer opacity-0')}
          type="checkbox"
          value={data.id}
          name={name}
          checked={selected}
          onChange={(event) => {
            if (event.currentTarget.checked) {
              startTransition(() => handleChange(data.id.toString()));
            } else {
              startTransition(() => handleChange(''));
            }
          }}
        />
        {(isPending || disabled) && (
          <div className="rounded-box absolute flex h-full w-full cursor-default items-center justify-center bg-gray-500/50">
            {isPending && <div className="loading loading-sm" />}
          </div>
        )}
        {!!data.picture && (
          <Image
            className="rounded-box h-auto w-full object-contain"
            src={data.picture}
            alt={`${data.name} preview`}
            width={400}
            height={400}
          />
        )}
        <p className={clsx('w-fit', textClass)}>{data.name}</p>
      </div>
    </Tooltip>
  );
}
